<template>
  <div class="list">
    <div
      v-for="course in courses"
      :key="course.id"
      class="list__item"
    >
      <CourseBasicProgressItem :course="course" />
    </div>
  </div>
</template>

<script>
import CourseBasicProgressItem from '@/components/course/CourseBasicProgressItem'

export default {
  components: {
    CourseBasicProgressItem,
  },

  props: {
    courses: { type: Array, required: true }
  }
}
</script>

<style lang="scss" scoped>
  @import "@/assets/sass/mixins";

  .list {
    @include children-gap(15px);
  }
</style>